/**
 * Variable staircasee : conceptuellement `speed_units` (NeuroTracker), reutilise
 * le slot `duration_ms` du union ferme `StaircaseVariable`. L'engine ignore la
 * semantique de la variable — il consomme la magnitude. Le label reel cote
 * analytics est porte par `paradigmMeta.slug` et le wiki spec.
 */
export const staircaseConfig = {
    gameSlug: '3d-mot',
    category: 'air_attention',
    variable: 'duration_ms',
    startValue: 1.0,
    minValue: 0.3,
    maxValue: 8.0,
    stepSizesByPhase: [0.4, 0.2, 0.1, 0.05],
    reversalsToConverge: 4,
    reversalsForThreshold: 3,
    maxTrials: 24,
    direction: 'up-easier',
};
function buildVariant(level) {
    // Progression monotone non-decroissante (nSpheres ↗, nTargets ↗) pour
    // garantir que la difficulte qualitative ne regresse jamais entre paliers.
    if (level <= 10) {
        return { level, nSpheres: 8, nTargets: 4, label: 'Tracking standard' };
    }
    if (level <= 20) {
        return { level, nSpheres: 12, nTargets: 4, label: 'Densite augmentee' };
    }
    if (level <= 30) {
        return { level, nSpheres: 12, nTargets: 5, label: 'Cinq cibles' };
    }
    if (level <= 40) {
        return { level, nSpheres: 13, nTargets: 5, label: 'Cinq cibles densite' };
    }
    return { level, nSpheres: 14, nTargets: 5, label: 'Limite tracking' };
}
export const levels = Array.from({ length: 50 }, (_, i) => buildVariant(i + 1));
export function variantForLevel(level) {
    const idx = Math.max(1, Math.min(50, level)) - 1;
    return levels[idx];
}
/** Durees non-staircase (ms). */
export const timing = {
    fixationMs: 600,
    /** Phase indication : les cibles flashent en rouge. */
    indicationMs: 2000,
    /** Phase motion : toutes les spheres bougent. */
    motionMs: 8000,
    /** Phase freeze : tout est immobile avant input. */
    freezeMs: 300,
    feedbackMs: 600,
    itiMs: 800,
};
export const paradigmMeta = {
    slug: '3d-mot',
    paradigm: '3D Multiple Object Tracking (Pylyshyn & Storm 1988 / Faubert 2013)',
    // Champ legacy — pas affiche cote UI. Conserve ici pour metadata interne.
    masterMage: 'Inori · Garek',
    category: 'air_attention',
    goal: "Suivi 3D : garde l'oeil sur 4 cibles parmi 8 spheres en mouvement.",
};
//# sourceMappingURL=params.js.map